import { render, staticRenderFns } from "./ModalHistoryCredit.vue?vue&type=template&id=353bd3c6&"
import script from "./ModalHistoryCredit.vue?vue&type=script&lang=js&"
export * from "./ModalHistoryCredit.vue?vue&type=script&lang=js&"
import style0 from "./ModalHistoryCredit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports